import { render, staticRenderFns } from "./deleteResourceStoreType.vue?vue&type=template&id=0f058b35&scoped=true"
import script from "./deleteResourceStoreType.vue?vue&type=script&lang=js"
export * from "./deleteResourceStoreType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f058b35",
  null
  
)

export default component.exports